import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PropertySingleLine.css";
import "./PropertySingleLineHeader.css";
import map from "./map.gif";
import gallery from "./gallery.gif";
//import properties from "./properties.json";
import { SyntheticEvent } from "react";
import PropertySingleLinePDF from "./share-to-pdf/PropertySingleLine";
import { PDF_PREVIEW_ID } from "./constants";
import { ImageCount } from "./ImageCount";
import { downloader } from "./share-to-pdf/downloader";
import printer from "./printer.png";
import pdf from "./pdf.png";
import { create_link } from "./lib/create-link";
import { getEnvironment } from "./Utils";
import { WhatToPrint, ViewMode } from "./types";
import { shouldPrintImages } from "./WhatToPrint";
import { initGlobalState } from "./CrappyGlobalState";
import { SHARE_LINK_ELEMENT, showShareableLink, hideShareableLink,} from "./InvalidateShareLink";
import { get_source } from "./lib/source";
import { PropertiesFile } from "./types";

const dd = console.debug;
const MAX_PDF_ENTRIES: number = 10;
const MINIMUM_SECONDS: number = 3;
function getTime(): number {
  return Math.floor(Date.now() / 1_000);
}
interface PropertySingleLineHeaderProps {
  view_mode: ViewMode;
  properties: PropertiesFile|null;
}

function PropertySingleLineHeader(props: PropertySingleLineHeaderProps) {
  const PROGRESS_ID: string = "pdf-progress-element";
  const [selectAll, setSelectAll] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const [readyForPrint, setReadyForPrint] = React.useState<boolean>(false);
  const [pdfIsGenerating, setPdfIsGenerating] = React.useState<boolean>(false);
  const [linkIsGenerating, setLinkIsGenerating] =
    React.useState<boolean>(false);
  const [shareLink, setShareLink] = React.useState<URL | null>(null);
  const [whatToPrint, setWhatToPrint] = React.useState<WhatToPrint>(
    "print-selected-no-images"
  );
  const [hintMessage, setHintMessage] = React.useState<string | null>(null);
  const [showCopied,setShowCopied] = React.useState<boolean>(false);
  function revertErrorMessageInFuture(seconds: number) {
    window.setTimeout(() => {
      setErrorMessage(null);
    }, seconds * 1000);
  }
  function isLocal(): boolean {
    return ["0.0.0.0", "localhost"].includes(window.location.hostname);
  }
  function unselectEverything() {
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((value: Element) => {
        (value as HTMLInputElement).checked = false;
      });
  }

  function cancelPDFProcess(event: SyntheticEvent) {
    event.preventDefault();
    if (window.confirm("Are you sure you want to cancel?")) {
      window.location.reload();
      return;
    }
  }
  function downloadingContent() {
    (async () => {
      const ele = document.getElementById("loaded-info");
      if (ele) {
        ele.innerHTML = [
          `<b class="pdf-dl-on-its-way">[OK] Your download is on it's way...</b>`,
          `<b class="pdf-pls-b-patient">Do not close your browser window</b>`,
          `<b class="pdf-pls-b-patient">This could take a few minutes to complete, so please be patient</b>`,
        ].join("<br/>");

        const resp = await downloader(PDF_PREVIEW_ID).catch(() => {
          return null;
        });
        if (resp === "ok") {
          ele.innerHTML = [
            `<b class="pdf-dl-is-on-its-way">PDF Generated Successfully<b>`,
            `<p class="pdf-check-ur-dls">Check your Downloads Folder</p>`,
          ].join("<br/>");
        } else {
          ele.innerText =
            "The PDF could not be generated. Please try again at a later date.";
        }
      }
      setErrorMessage(null);
      setPdfIsGenerating(false);
      window.setTimeout(() => {
        setReadyForPrint(false);
      }, 5_000);
      global.lombardo.total_images_to_load = 0;
      global.lombardo.rendered = [];
      unselectEverything();
    })();
  }
  function doLoadingScreen() {
    if (shouldPrintImages(whatToPrint)) {
      const interval = window.setInterval(() => {
        const ele = document.getElementById(PROGRESS_ID);
        if (ele) {
          ele.innerText = `${global.lombardo.rendered.length}/${global.lombardo.total_images_to_load} images loaded...`;
          if (
            global.lombardo.rendered.length >=
            global.lombardo.total_images_to_load
          ) {
            window.clearInterval(interval);
            downloadingContent();
          }
        }
      }, 800);
    } else {
      const interval = window.setInterval(() => {
        const ele = document.getElementById(PROGRESS_ID);
        if (ele) {
          for (const p_id of global.lombardo.selected) {
            const div = document.querySelector(
              `#psl-load-hack-${String(p_id).replace(/[^a-z0-9]+/gi, "")}`
            );
            if (div) {
              if (global.lombardo.property_rendered.indexOf(p_id) === -1) {
                global.lombardo.property_rendered.push(p_id);
                break;
              }
            }
          }

          ele.innerText = `${global.lombardo.property_rendered.length}/${global.lombardo.selected.length} properties loaded...`;
          if (
            global.lombardo.property_rendered.length >=
            global.lombardo.selected.length
          ) {
            window.clearInterval(interval);
            downloadingContent();
          }
        }
      }, 2_000);
    }
  }
  function calculateImageTotal() {
    global.lombardo.total_images_to_load = 0;
    for (const property_id of global.lombardo.selected) {
      (async () => {
        const count: number | null = await ImageCount(property_id);
        if (count !== null) {
          global.lombardo.total_images_to_load += count;
        }
      })();
    }
  }
  function shareAsPDFImagesHandler(event: SyntheticEvent) {
    event.preventDefault();
    if (global.lombardo.selected.length === 0) {
      setErrorMessage("You must select atleast one property");
      return;
    }
    if (global.lombardo.selected.length > MAX_PDF_ENTRIES) {
      setErrorMessage(
        `The PDF function currently only allows ${MAX_PDF_ENTRIES} max properties.`
      );
      setHintMessage(
        `If you would like to save every listing, use the Print button and select "Save As PDF"`
      );
      return;
    }
    setPdfIsGenerating(true);
    setReadyForPrint(true);
    if (shouldPrintImages(whatToPrint)) {
      calculateImageTotal();
    }
    doLoadingScreen();
  }

  function toggleSelectAll() {
    if (selectAll) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
    setShareLink(null);
    hideShareableLink();
  }
  function startGeneratingLink() {
    if (global.lombardo.selected.length === 0) {
      setErrorMessage("Please select atleast one property first");
      revertErrorMessageInFuture(8);
      return;
    }
    setLinkIsGenerating(true);
    setShareLink(null);
    if (isLocal()) {
      window.setTimeout(() => {
        setShareLink(new URL("http://0.0.0.0:3000/share?id=4"));
        setLinkIsGenerating(false);
        setErrorMessage(null);
      }, 3_000);
      return;
    }
    try {
      type LinkResponse = [number | null, Request];
      let time_start: number = getTime();
      let time_end: number = time_start;
      create_link(global.lombardo.selected)
        .then((value: LinkResponse) => {
          console.debug("create_link.then triggered");
          if (value[0] === null) {
            setErrorMessage("Unable to generate a link right now");
            revertErrorMessageInFuture(5);
            return;
          }
          time_end = getTime();
          const elapsed_time: number = Math.abs(time_start - time_end);
          let seconds_to_wait: number = MINIMUM_SECONDS - elapsed_time;
          if (seconds_to_wait < 0) {
            seconds_to_wait = 0;
          }
          window.setTimeout(() => {
            const u: URL = new URL("https://lombardohomesandestates.com/");
            u.pathname = "/mls-properties/";
            if (getEnvironment() === "staging") {
              u.pathname = "/staging/";
            }
            u.searchParams.set("share", String(value[0]));
            setShareLink(u);
            setLinkIsGenerating(false);
            setErrorMessage(null);
          }, seconds_to_wait * 1_000);
        })
        .catch((reason) => {
          console.debug("create_link.catch triggered");
          console.error("create_link failed with:", { reason });
          if (reason instanceof Error && reason.message === "Aborted") {
            setErrorMessage("Canceled");
            revertErrorMessageInFuture(5);
            return;
          }
          setLinkIsGenerating(false);
          setErrorMessage("Unable to generate a link at this time");
        });
    } catch (err) {
      setLinkIsGenerating(false);
      console.debug("create_link try/catch, catch triggered", { err });
      setErrorMessage(`The following error occurred: "${String(err)}"`);
    }
  }
  function printDocument(event: SyntheticEvent) {
    event.preventDefault();

    let number_of_properties_checked: number = 0;
    document
      .querySelectorAll('input[type="checkbox"]')
      .values()
      .find((value: Element) => {
        if ((value as HTMLInputElement).checked) {
          ++number_of_properties_checked;
        }
        if (number_of_properties_checked >= 1) {
          return true;
        }
      });
    if (number_of_properties_checked > 0) {
    }
    window.print();
  }
  function copyToClipboard(event: SyntheticEvent) {
    event.preventDefault();
    setShowCopied(false);
    if (shareLink) {
      try {
        navigator.clipboard.writeText(shareLink.toString())
        .then(() => {
          setShowCopied(true);
          window.setTimeout(() => {
            setShowCopied(false);
          },2500);
        })
        .catch((reason) => {
          console.error("Unable to copy url to clipboard:", reason);
        });
        return;
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
        setErrorMessage("Unable to copy URL to clipboard");
        return;
      }
    }
    setErrorMessage("Nothing to copy");
  }
  React.useEffect(() => {
    initGlobalState();
    global.lombardo.selected = [];
    global.lombardo.rendered = [];
    document
      .querySelectorAll('input[type="checkbox"]')
      .forEach((value: Element) => {
        (value as HTMLInputElement).checked = selectAll;
      });
    for (const key in props.properties) {
      dd({key},'<< in properties');
      const k = document.querySelector(`[data-property="${String(key).replace(/^KEY/,'')}"]`);
      if (!k) {
        continue;
      }
      const d = k.parentNode?.parentNode?.parentNode as HTMLDivElement;
      if (d) {
        if (selectAll) {
          d.classList.add("psl-selected");
          global.lombardo.selected.push(key);
        } else {
          d.classList.remove("psl-selected");
          global.lombardo.selected = global.lombardo.selected.filter(
            (value: string) => {
              return value !== key;
            }
          );
        }
      }
    }
    if (global.lombardo.selected.length) {
      setErrorMessage(null);
    }
  }, [selectAll]);

  return (
    <div className="PropertySingleLineHeaderWrapper">
      {pdfIsGenerating === true && (
        <div className="zi-top pdf-is-generating no-print">
          <p className="zi-top pdf-gen-status">Generating PDF...</p>
          <b className="zi-top pdf-progress" id={PROGRESS_ID}>
            &nbsp;
          </b>
          <b className="zi-top" id="loaded-info">
            &nbsp;
          </b>
          <button className="zi-top pdf-cancel" onClick={cancelPDFProcess}>
            Cancel
          </button>
        </div>
      )}
      {pdfIsGenerating === false && (
        <div className="pslh-share-interface-wrapper no-print">
          <div
            className={
              "share-modal-buttons " +
              (props.view_mode === "icons" ? "smb-icons" : "")
            }
          >
            {props.view_mode !== "icons" && (
              <>
                <button
                  className="share-button-generic pslh-share"
                  onClick={printDocument}
                >
                  <img src={printer} className="share-button-copy-icon" />
                  Print
                </button>
                <button
                  className="share-button-generic pslh-share"
                  onClick={shareAsPDFImagesHandler}
                >
                  <img src={pdf} className="share-button-copy-icon" />
                  PDF
                </button>
              </>
            )}
            <button
              className={
                "share-button-generic pslh-share " +
                (props.view_mode === "icons"
                  ? "share-link-icons"
                  : "share-link-single-line") +
                (linkIsGenerating === true ? 
                ' link-loading' : '')
              }
              onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                if(linkIsGenerating){
                  //cancelCopyLinkHandler(e);
                  return;
                }
                startGeneratingLink();
                showShareableLink();
              }}
            >
              {linkIsGenerating === true && <>Loading...</>}
              {linkIsGenerating === false && <>Get shareable link</>}
            </button>
          </div>
          {
          <div className="pslh-copy-inputs-wrapper share-modal-buttons" id={SHARE_LINK_ELEMENT}>
            {shareLink !== null && (
            <div className="pslh-minify-container">
                <input
                  className="share-link"
                  type="text"
                  value={shareLink.toString()}
                ></input>
                <button
                  className="share-button-generic pslh-copy-btn"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                {showCopied && <b className="copied-notification-text">Copied!</b>}
            </div>
            )}
          </div>
          }
          <div className="mandatory-space-for-messages">
            {errorMessage !== null && (
              <b className="error mandatory-space-message" id="psl-error-msg">
                {errorMessage}
              </b>
            )}
            {hintMessage !== null && (
              <b
                className="psl-hint-message mandatory-space-message"
                id="psl-hint-msg"
              >
                {hintMessage}
              </b>
            )}
            <br />
          </div>
          {props.view_mode !== "icons" && (
            <select
              className="sort-by-select choose-what-to-print"
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                setWhatToPrint(event.currentTarget.value as WhatToPrint);
              }}
              value={whatToPrint}
            >
              <option value="print-selected">Print Selected</option>
              <option value="print-selected-no-images">
                Print Selected (No Images)
              </option>
              <option value="print-it-all">Print All</option>
              <option value="print-it-all-no-images">
                Print All (No Images)
              </option>
            </select>
          )}
        </div>
      )}
      <div id={PDF_PREVIEW_ID} className="pdf-preview pdf-preview-visible">
        {readyForPrint &&
          global.lombardo.selected.map((value: string, index: number) => {
            return (
              <>
                <PropertySingleLinePDF
                  key={index}
                  property_id={value}
                  sort_mode="newest"
                  display_mode="show-all"
                  what_to_print={whatToPrint}
                  on_done_rendering={(property_id: string) => {
                    global.lombardo.property_rendered.push(property_id);
                  }}
                  source={get_source()}
                />
                <div className="html2pdf__page-break">&nbsp;</div>
              </>
            );
          })}
      </div>
      <div
        className={
          "PropertySingleLine psl-override-header-color left-adjust " +
          (props.view_mode === "icons" ? "psl-hidden" : "")
        }
      >
        <div className="psl-table-wrapper">
          <div className="psl-entry">
            <div className="psl-cell">
              <div className="psl-column no-print">
                <input
                  type="checkbox"
                  className="psl-select"
                  onClick={() => toggleSelectAll()}
                ></input>
              </div>
              <div className="psl-column psl-map no-print">
                <a onClick={(e) => e.preventDefault()}>
                  <img src={map} className="psl-invis-img"></img>
                </a>
              </div>
              <div className="psl-column psl-gallery no-print">
                <button
                  className="psl-invis-img psl-button-no-border"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={gallery} className="psl-invis-img"></img>
                </button>
              </div>
              <div className="psl-column psl-mls">MLS#</div>
              <div className="psl-column psl-status">St</div>
              <div className="psl-column psl-inc"></div>
              <div className="psl-column psl-price">Price</div>
              <div className="psl-column psl-type">Type</div>
              <div className="psl-column psl-subtype">Subtype</div>
              <div className="psl-column psl-addr">Address</div>
              <div className="psl-column psl-town">Post Office/Town</div>
              <div className="psl-column psl-sqft">Liv Sqft</div>
              <div className="psl-column psl-lotsz">Lot Sz</div>
              <div className="psl-column psl-br">BR</div>
              <div className="psl-column psl-fb">FB</div>
              <div className="psl-column psl-hb">HB</div>
              <div className="psl-column psl-year">Yr Blt</div>
              <div className="psl-column psl-dom">DOM</div>
            </div>
          </div>
        </div>
      </div>
      {pdfIsGenerating === true && <div id="pdf-blocker-ui">&nbsp;</div>}
    </div>
  );
}

export default PropertySingleLineHeader;
